import {useOnMount} from 'shared/web';

/** Managed dialogs close on navigation. Dispatch after the URL update commits. */
export function InvokeBulkOperationAction(props: {invoke: () => void}) {
  useOnMount(() => queueMicrotask(props.invoke));
  return null;
}
